import { render, staticRenderFns } from "./ProductInformationDisclosurePopupIframe.vue?vue&type=template&id=76b1c60c&"
import script from "./ProductInformationDisclosurePopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductInformationDisclosurePopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports